
import { Options, Vue } from "vue-property-decorator";

@Options({})
export default class TransitionStyle extends Vue {}
